/** @jsxRuntime classic */
/** @jsx jsx */

import AppStoreBadge from "components/app-store-badge";
import CommonHead from "components/common-head";
import CommonPostBody from "components/common-post-body";
import PlayStoreBadge from "components/play-store-badge";
import SecondaryLayout from "components/secondary-layout";
import SEO from "components/seo";
import { useParamsSuffix } from "helpers/urls";
import useMobileDetect from "hooks/mobile-detect";
import Head from "next/head";
import Router from "next/router";
import React, { useEffect } from "react";
import { appTheme } from "theme";
import { jsx, Container, ThemeProvider, Heading, Flex } from "theme-ui";
import { SEO_AUTHOR, SEO_META } from "../constants";

export default function IOSPage() {
  const { isAndroid, isIos } = useMobileDetect();
  const paramsSuffix = useParamsSuffix();

  useEffect(() => {
    if (isAndroid()) {
      Router.push("/android" + paramsSuffix);
    } else if (isIos()) {
      Router.push("/ios" + paramsSuffix);
    }
  });

  return (
    <ThemeProvider theme={appTheme}>
      <SecondaryLayout>
        <CommonHead />
        <SEO
          title="oneCoach Mobile App"
          description="Easy step-by-step online tennis instruction broken down so you can learn tennis on autopilot. Download the oneCoach mobile app here."
          author={SEO_AUTHOR}
          meta={SEO_META}
        />
        <Head>
          <meta name="robots" content="noindex" />
        </Head>
        <div id="root">
          <CommonPostBody />
          <section sx={{ variant: "section.general" }}>
            <Container>
              <Flex
                py={8}
                sx={{
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Heading as="h2" sx={{ textAlign: "center" }}>
                  Navigate to this page on your phone to download the oneCoach
                  app.
                </Heading>
                <Heading as="h4" sx={{ textAlign: "center", py: 4 }}>
                  Access our library of tennis masterclasses for all skill
                  levels, beginners or advanced. It's free!
                </Heading>
                <Flex my={3}>
                  <AppStoreBadge eventSuffix="download" />
                  <PlayStoreBadge eventSuffix="download" />
                </Flex>
              </Flex>
            </Container>
          </section>
        </div>
      </SecondaryLayout>
    </ThemeProvider>
  );
}
